//@flow
import React from 'react';
import MsrpToggleButton from './MsrpToggleButton.react';
import ModalActions from '../../Actions/modal';
import Constants from '../../constants';

type Props = {
  membershipDiscount:number,
  quoteId:?string,
  className:string,
  isMsrp:boolean,
};

function _openModal() {
  ModalActions.openModal(Constants.MSRP_POP_MODAL);
}

export default function MsrpToggle(props:Props) {
  const discount = props.membershipDiscount.toFixed(2);
  return(
    <div className={`msrp-toggle text-4 ${props.className}`}>
      <MsrpToggleButton
        quoteId={props.quoteId}
        isMsrp={props.isMsrp}
        id="MsrpToggleButton"
      />
      <span className="body">
        Become a member and save
        <span className="discount bold"> ${discount} </span>
      </span>
      <span onClick={_openModal} className="learn-more"/>
    </div>
  );
}
